export default "__VITE_ASSET__DQSQpjDv__"